import { EBaseOrderDirection } from 'common/models/requestModels';
import { AbstractSearchableSelector } from 'common/components/Input/AbstractSearchableSelector';
import { ECategoryType, ICategoryCollectionFilter, ICategoryModel } from 'entities/Category/Category.models';
import { categoryTransport } from 'entities/Category/Category.transport';
import { ECommonEntityStatus } from 'entities/Bitecoin/Bitecoin.models';

interface IComponentProps {
  isAddOns?: boolean;
  // Exact add-ons-setting and Meal Builder filters — used by the Display Category dropdown so it only
  // lists categories matching the chosen Permanent Category (incl. its MB role and drink temperature).
  type?: ECategoryType;
  isMealBuilder?: boolean;
  mealBuilderRole?: ICategoryModel['mealBuilderRole'];
  drinkTemperature?: ICategoryModel['drinkTemperature'];
}

export class CategorySelector extends AbstractSearchableSelector<ICategoryModel, IComponentProps> {
  componentDidUpdate(prevProps: Readonly<CategorySelector['props']>) {
    // Re-fetch when the active filters change (e.g. the Permanent Category selection drives these),
    // otherwise the dropdown keeps stale options from the initial mount.
    if (
      prevProps.type !== this.props.type ||
      prevProps.isMealBuilder !== this.props.isMealBuilder ||
      prevProps.mealBuilderRole !== this.props.mealBuilderRole ||
      prevProps.drinkTemperature !== this.props.drinkTemperature
    ) {
      this.getCollection();
    }
  }

  getItemLabel = (item: ICategoryModel) => {
    return item.name;
  };

  loadData = (value?: string) => {
    const { isAddOns, type, isMealBuilder, mealBuilderRole, drinkTemperature } = this.props;
    const filterParams: ICategoryCollectionFilter = {
      name: value,
      orderField: 'name',
      orderDirection: EBaseOrderDirection.ASC,
      statuses: [ECommonEntityStatus.Active]
    };
    if (isAddOns !== undefined) {
      filterParams.isAddOns = isAddOns;
    }
    if (type !== undefined) {
      filterParams.type = type;
    }
    if (isMealBuilder !== undefined) {
      filterParams.isMealBuilder = isMealBuilder;
    }
    // Role + temperature only apply to MB categories (sides have no temperature → null is skipped).
    if (mealBuilderRole) {
      filterParams.mealBuilderRole = mealBuilderRole;
    }
    if (drinkTemperature) {
      filterParams.drinkTemperature = drinkTemperature;
    }

    return categoryTransport.getCollection(filterParams);
  };
}
